import { PageHero } from '@/components/ui/PageHero'
import { patientBioScan } from '@/assets/siteMedia'

export const BioScanHero = () => (
  <PageHero
    image={patientBioScan}
    imageAlt="A client having a Bio-Scan reading taken while Kandake reviews the results on screen"
    imagePosition="object-[30%_50%]"
    highlights={[
      'Non-invasive assessment',
      'One hour of personal feedback',
      'Summary & first steps',
    ]}
    title="A broader look at your health,"
    accent="with guidance you can use."
    description={
      <>
        <p>
          Sometimes you know that something in your health needs attention, but you are not quite
          sure where to begin.
        </p>
        <p className="text-base text-green-100">
          The Instrumental Health Bio-Scan is a non-invasive holistic health assessment that
          provides a broad overview across multiple areas of health and wellbeing.
        </p>
      </>
    }
  />
)
